module.exports = __webpack_public_path__ + "assets/img/new-logo.4fea0952.png";